<div
  class="so-modal-layout"
  [class.so-modal-layout--auto]="surfaceHeightMode() === 'auto'"
  [style.min-height]="layoutMinHeight()"
  [style.max-height]="layoutMaxHeight()"
>
  <!-- Header -->
  @if (showHeader()) {
    <div class="modal-header">
      <div class="header-left">
        @if (headerLeft) {
          <ng-container *ngTemplateOutlet="headerLeft"></ng-container>
        } @else {
          @if (icon()) {
            <so-premium-icon-ui
              [icon]="icon()"
              [color]="iconColor()"
              [size]="iconSize()"
            ></so-premium-icon-ui>
          }
          @if (title() || subtitle()) {
            <div class="header-text">
              @if (title()) {
                <h2 class="so-subtitle m-0">{{ title() }}</h2>
              }
              @if (subtitle()) {
                <p class="so-text-4 so-gray-thick m-0">{{ subtitle() }}</p>
              }
            </div>
          }
        }
      </div>
      @if (headerRight) {
        <div class="header-right">
          <ng-container *ngTemplateOutlet="headerRight"></ng-container>
        </div>
      }
    </div>
  }

  <!-- Content -->
  <div class="modal-content" [class.disabled-content]="contentDisabled()" [style.padding]="contentPadding()">
    <ng-content></ng-content>
  </div>

  <!-- Footer -->
  @if (showFooter()) {
    <div class="modal-footer" [class]="'footer-' + footerAlign()">
      @if (footerLeft) {
        <div class="footer-left">
          <ng-container *ngTemplateOutlet="footerLeft"></ng-container>
        </div>
      }
      @if (footerCenter) {
        <div class="footer-center">
          <ng-container *ngTemplateOutlet="footerCenter"></ng-container>
        </div>
      }
      @if (footerRight) {
        <div class="footer-right">
          <ng-container *ngTemplateOutlet="footerRight"></ng-container>
        </div>
      }
      <ng-content select="[slot=footer]"></ng-content>
    </div>
  }
</div>
